import * as React from "react";
import { useForm } from "react-hook-form";
import { RotateCcwSquare } from "lucide-react";
import TextareaAutosize from "react-textarea-autosize";
import { KeyBoardCodeEnter } from "@/types/keybord";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";

interface PromptGeneratorFormProps {
  handleImprovePrompt: (query: string) => void;
  isDisabled: boolean;
}

interface FormInputs {
  query: string;
}

export const PromptGeneratorForm: React.FC<PromptGeneratorFormProps> = ({ isDisabled, handleImprovePrompt }) => {
  const methods = useForm<FormInputs>();

  const { promptToImprove, sendPromptToImprove } = usePromptGeneratorContext();

  React.useEffect(() => {
    if (promptToImprove) {
      handleImprovePrompt(promptToImprove);
      sendPromptToImprove(null);
    }
  }, [handleImprovePrompt, promptToImprove, sendPromptToImprove]);

  const onSubmit = (payload: FormInputs) => {
    handleImprovePrompt(payload.query);
    methods.reset();
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.code === KeyBoardCodeEnter && !event.shiftKey) {
      event.preventDefault();
      onSubmit(methods.getValues());
    }
  };

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} className="flex h-full items-center rounded-xl bg-white px-4">
      <TextareaAutosize
        {...methods.register("query")}
        placeholder="Type prompt to improve"
        className="flex-grow resize-none border-none py-2 focus:outline-none focus:ring-0"
        onKeyDown={handleKeyPress}
        readOnly={isDisabled}
        maxRows={5}
      />
      <button
        type="submit"
        disabled={isDisabled}
        className="ml-4 rounded-full bg-desert-sand-700 p-2 text-white hover:bg-desert-sand-900"
      >
        <RotateCcwSquare size={15} />
      </button>
    </form>
  );
};
